import { render, staticRenderFns } from "./PenalidadesView.vue?vue&type=template&id=53103d04"
import script from "./PenalidadesView.vue?vue&type=script&lang=js"
export * from "./PenalidadesView.vue?vue&type=script&lang=js"
import style0 from "./PenalidadesView.vue?vue&type=style&index=0&id=53103d04&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports